import { useEffect, useState } from "react";
import { PipelinesMenu } from "@/types/domain";
import { fetchPipelinesMenu } from "@/api/menu/api";
import { flyoutRowClass } from "./flyoutStyles";

export const PipelinesSubMenu = ({ onActivated }: { onActivated?: () => void }) => {
  const [pipelinesData, setPipelinesData] = useState<PipelinesMenu | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchPipelinesMenu(window.location.href)
      .then((data) => {
        setPipelinesData(data ?? null);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, []);

  if (!loaded) {
    return <li className="px-2 py-2 text-sm text-slate-500">Loading…</li>;
  }

  if (!pipelinesData?.pipelines.length) {
    return <li className="px-2 py-2 text-sm text-slate-500">No pipelines</li>;
  }

  return (
    <>
      {pipelinesData.pipelines.map((p) => (
        <li key={p.id}>
          <a
            href={`/Pipeline/Index/${p.id}`}
            data-flyout-item
            onClick={onActivated}
            className={flyoutRowClass(pipelinesData.selectedPipelineId === p.id)}
          >
            <span className="truncate">{p.name}</span>
          </a>
        </li>
      ))}
    </>
  );
}
